export default __webpack_public_path__ + "static/media/me-again.0675d802.jpg";